<div class="box">
  <div class="myForm">
    <div class="card">
      <h4 class="card-header">Import Chatbot flow using Excel Template</h4>
      <div class="card-body scroll">
        <form #chatbotForm="ngForm">
          <p>
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Client</mat-label>
              <mat-select name="client" placeholder="Client" [(ngModel)]="chatbot.client" required>
                <mat-option *ngFor="let item of clients" [value]="item.id">{{item.dname}}</mat-option>
              </mat-select>
              <mat-error>*Client is required</mat-error>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Type</mat-label>
              <mat-select name="type" placeholder="Type" [(ngModel)]="chatbot.type" required>
                <mat-option *ngFor="let item of chatbotTypes" [value]="item.id">{{ item.dname }}</mat-option>
              </mat-select>
              <mat-error>*Type is required</mat-error>
            </mat-form-field>
          </p>
          <p>
            <button class="button" color="primary" type="button" mat-raised-button (click)="fileInput.click()" required>
              <mat-icon>attachment</mat-icon>
              Excel File*
            </button>
            <input hidden (change)="onFileSelected($event)" #fileInput name="xl" type="file" accept=".xls, .xlsx"
              [(ngModel)]="chatbot.xl" #xl="ngModel" required />
            <br>
            <span>
              <mat-hint><b>{{ chatbot.xl?.name ? chatbot.xl?.name : "&nbsp;" }}
                  <button color="primary" class="remove" *ngIf="chatbot.xl?.name" mat-button (click)="remove()">
                    <mat-icon>delete_forever</mat-icon>
                  </button>
                </b></mat-hint> 
            </span>
          </p>
          <p>
            <button color="primary" class="button" type="button" mat-raised-button (click)="fileInput1.click()"
              required>
              <mat-icon>attachment</mat-icon>
              Assets Zip
            </button>
            <input hidden (change)="onFileSelected1($event)" #fileInput1 name="zip" type="file" accept=".zip"
              [(ngModel)]="chatbot.zip" #zip="ngModel" />
            <br>
            <span>
              <mat-hint><b>{{ chatbot.zip?.name ? chatbot.zip?.name : "&nbsp;" }}
                  <button color="primary" class="remove" *ngIf="chatbot.zip?.name" mat-button (click)="remove1()">
                    <mat-icon>delete_forever</mat-icon>
                  </button>
                </b></mat-hint>
            </span>
          </p>
          <p>
            <button color="primary" class="button btn-spc" [disabled]="!chatbotForm.valid || buttonClicked"
              (click)="upload(false)" mat-raised-button>
              {{ buttonClicked && !status ? "Verifying" : "Verify" }}
              <span>
                <mat-icon *ngIf="buttonClicked && !status">
                  <mat-spinner diameter="25"></mat-spinner>
                </mat-icon>
              </span>
            </button>
          </p>
          <p>
            <button color="primary" class="button float-left" [disabled]="!success || resp == null"
              (click)="response( true )" mat-raised-button> View
              Log </button>
            <button color="primary" class="button float-right" [disabled]="!chatbotForm.valid || buttonClicked"
              (click)="upload(true)" type="submit" mat-raised-button>
              {{ buttonClicked && status ? "Uploading" : "Upload" }}
              <span>
                <mat-icon *ngIf="buttonClicked && status">
                  <mat-spinner diameter="25"></mat-spinner>
                </mat-icon>
              </span>
            </button>
          </p>
        </form>
      </div>
    </div>
  </div>
</div>